import { RegisteredComponent } from "@builder.io/sdk-react";

export const hushlyEmbedBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Hushly Embed",
  image:
    "https://s3.us-west-1.amazonaws.com/statics.hushly.com/1/8a1tb1gk9g2o8feqvu3hqge59f.png",
  inputs: [
    {
      name: "embedId",
      type: "string",
      required: true,
      localized: false,
    },
  ],
};
